export default __webpack_public_path__ + "static/media/graduate-student.89b83b89.png";